import { cloneDeep, merge } from 'lodash'

import { matchPetsToVisit } from '../../services/helpers'
import {
	STATUS_ID,
	GROOMING_SERVICE_TYPES,
	GROOMING_SERVICE_LABELS,
	STATIC_GROOMING_SERVICES,
	APPOINTMENT_TYPE_FILTERS
} from '../../utils'

const initialState = {
	loading: false,
	error: null,
	visits: null,
	training_enrollments: [],
	tests: null,
	selected: null,
	pets: null,
	invoiceLoading: false,
	selectedFilters: {
		appointment_type: [],
		appointment_status: [],
		arriving_today: false,
		departing_today: false,
		drop_off_type: [],
		pick_up_type: [],
		hasAlerts: false
	},
	selectedGroomingFilters: {
		service_type: [],
		appointment_status: [],
		hasAlerts: false
	},
	selectedHouseholdFilters: {
		appointment_type: [],
		appointment_status: []
	},
	selectedGroomingAssignmentFilters: {
		team_member: [],
		role: []
	},
	grooming_assignment_filters: {
		team_member: [],
		role: [
			{
				value: 'Groomer',
				label: 'Groomer'
			},
			{
				value: 'Groom Tech',
				label: 'Groom Tech'
			}
		]
	},
	grooming_filters: {
		service_type: STATIC_GROOMING_SERVICES,
		appointment_status: [
			{ value: STATUS_ID.Pending, label: 'Pending' },
			{ value: STATUS_ID.Approved, label: 'Approved' },
			{ value: STATUS_ID.InProgress, label: 'In-Progress' },
			{ value: STATUS_ID.Completed, label: 'Completed' },
			{ value: STATUS_ID.Cancelled, label: 'Cancelled' },
			{ value: STATUS_ID['No Show'], label: 'No Show' }
		],
		hasAlerts: {
			value: 'has_alerts',
			label: 'Has Alerts'
		}
	},
	household_appts_filters: {
		appointment_type: [
			{ value: 'boarding', label: 'Boarding' },
			{ value: 'daycare', label: 'Daycare' },
			{ value: 'grooming', label: 'Grooming' },
			{ value: 'welcome_days', label: 'Welcome Day' },
			{ value: 'training_class', label: 'Training Class' }
		],
		appointment_status: [
			{ value: STATUS_ID.Approved, label: 'Approved' },
			{ value: STATUS_ID.InProgress, label: 'In-Progress' },
			{ value: STATUS_ID.Completed, label: 'Completed' },
			{ value: STATUS_ID.Cancelled, label: 'Cancelled' },
			{ value: STATUS_ID['No Show'], label: 'No Show' }
		]
	},
	filters: {
		appointment_type: [
			{ value: 'boarding', label: 'Boarding' },
			{ value: 'daycare', label: 'Daycare' },
			{ value: APPOINTMENT_TYPE_FILTERS.WelcomeDay, label: 'Welcome Day' },
			{ value: APPOINTMENT_TYPE_FILTERS.SignatureStay, label: 'Signature Stay' },
			{ value: APPOINTMENT_TYPE_FILTERS.SignaturePlay, label: 'Signature Play' }
		],
		appointment_status: [
			{ value: STATUS_ID.Approved, label: 'Approved' },
			{ value: STATUS_ID.InProgress, label: 'In-Progress' },
			{ value: STATUS_ID.Completed, label: 'Completed' },
			{ value: STATUS_ID.Cancelled, label: 'Cancelled' },
			{ value: STATUS_ID['No Show'], label: 'No Show' }
		],
		arriving_today: {
			value: 'arriving_today',
			label: 'Arriving Today'
		},
		departing_today: {
			value: 'departing_today',
			label: 'Departing Today'
		},
		drop_off_type: [
			{
				value: 'early_dropoff',
				label: 'Arriving Early (6am-7am)'
			},
			{
				value: 'daycare_dropoff',
				label: 'Arriving Standard (7am-9am)'
			},
			{
				value: 'boarding_dropoff',
				label: 'Arriving Overnight (by 9pm)'
			}
		],
		pick_up_type: [
			{
				value: 'early',
				label: 'Departing AM (by 9am)'
			},
			{
				value: 'standard',
				label: 'Departing Standard (by 7pm)'
			},
			{
				value: 'late',
				label: 'Departing Late (by 9pm)'
			}
		],
		hasAlerts: {
			value: 'has_alerts',
			label: 'Has Alerts'
		}
	},
	selectedActivityFilters: {
		appointment_status: [],
		status: [],
		shift: [],
		'add-ons': [],
		meals: false,
		meds: false
	},
	activityfilters: {
		appointment_status: [
			{ value: STATUS_ID.Pending, label: 'Pending' },
			{ value: STATUS_ID.Approved, label: 'Approved' },
			{ value: STATUS_ID.InProgress, label: 'In-Progress' },
			{ value: STATUS_ID.Completed, label: 'Completed' }
		],
		status: [
			{ value: 'waiting', label: 'Waiting' },
			{ value: 'prepared', label: 'Prepared' },
			{ value: 'in_progress', label: 'In-Progress' },
			{ value: 'delivered', label: 'Delivered' },
			{ value: 'completed', label: 'Completed' }
		],
		shift: [
			{ value: 'morning', label: 'Morning' },
			{ value: 'midday', label: 'Midday' },
			{ value: 'evening', label: 'Evening' },
			{ value: 'night', label: 'Night' }
		],
		'add-ons': [],
		meals: {
			value: 'meals',
			label: 'Meals'
		},
		meds: {
			value: 'meds',
			label: 'Meds'
		}
	}
}

const visits = (state = initialState, action) => {
	switch (action.type) {
		case 'SET_GROOMING_FILTERS': {
			return {
				...state,
				grooming_filters: {
					...state.grooming_filters,
					service_type: [...STATIC_GROOMING_SERVICES, ...action.payload]
				}
			}
		}
		case 'SET_SELECTED_FILTERS':
			return { ...state, selectedFilters: action.payload }
		case 'SET_SELECTED_HOUSEHOLD_FILTERS': {
			return { ...state, selectedHouseholdFilters: action.payload }
		}
		case 'CLEAR_HOUSEHOLD_FILTERS': {
			return { ...state, selectedHouseholdFilters: { appointment_type: [], appointment_status: [] } }
		}
		case 'SET_SELECTED_GROOMING_FILTERS': {
			return { ...state, selectedGroomingFilters: action.payload }
		}
		case 'SET_GROOMING_TEAM': {
			return {
				...state,
				grooming_assignment_filters: {
					...state.grooming_assignment_filters,
					team_member: action.payload
				}
			}
		}
		case 'SET_SELECTED_GROOMING_ASSIGNMENT_FILTERS': {
			return { ...state, selectedGroomingAssignmentFilters: action.payload }
		}
		case 'SET_ACTIVITY_FILTERS':
			return { ...state, activityfilters: action.payload }
		case 'SET_SELECTED_ACTIVITY_FILTERS':
			return { ...state, selectedActivityFilters: action.payload }
		case 'GET_VISIT':
			return { ...state, loading: true, error: null }
		case 'GET_VISIT_FAIL':
			return { ...state, loading: false, error: action.payload }
		case 'GET_VISITS':
			return { ...state, loading: true, error: null }
		case 'GET_TRAINING_ENROLLMENTS':
			return { ...state, loading: true, error: null }
		case 'GET_VISITS_FAIL':
			return { ...state, loading: false, error: action.payload }
		case 'GET_TRAINING_ENROLLMENTS_FAIL':
			return { ...state, loading: false, error: action.payload }
		case 'RESET_APP':
			return { ...initialState }
		case 'MOVE_PETS': {
			const { visit_ids, playgroup, pet_ids } = action.payload
			const newVisits = state.visits.map((v) => {
				if (visit_ids.includes(v._id)) {
					const status_map = v.pet_status.map((stat) => {
						if (pet_ids.includes(stat.pet_id)) {
							console.log('yes indeed now...')
							stat.playgroup = playgroup
							stat.playgroup_id = playgroup
						}

						return stat
					})

					return {
						...v,
						pet_status: status_map
					}
				} else {
					return v
				}
			})

			let selected = state.selected ? { ...state.selected } : null

			if (state.selected && visit_ids.includes(state.selected._id)) {
				const status_map = selected.pet_status.map((stat) => {
					if (pet_ids.includes(stat.pet_id)) {
						stat.playgroup = playgroup
						stat.playgroup_id = playgroup
					}

					return stat
				})

				selected.pet_status = status_map
			}

			return {
				...state,
				selected,
				visits: newVisits,
				loading: false,
				error: null
			}
		}
		case 'SET_TRAINING_ENROLLMENTS':
			const training_enrollments = action.payload
			return {
				...state,
				training_enrollments,
				loading: false,
				error: null
			}

		case 'SET_VISITS':
			let { visits, tests, pets, add_on_services } = action.payload

			if (visits.length > 0) {
				visits = visits.map((visit) => {
					visit.add_on_services = add_on_services.filter(
						(add_on_service) => add_on_service.visit_id === visit._id
					)

					return visit
				})

				visits = visits.map((visit) => matchPetsToVisit(visit, pets))
			}

			return {
				...state,
				visits,
				tests,
				loading: false,
				error: null,
				pets
			}
		case 'ADD_NOTE': {
			const newNotes = [...state.selected.staff_notes, action.payload]

			return {
				...state,
				selected: {
					...state.selected,
					staff_notes: newNotes
				}
			}
		}
		case 'UPDATE_NOTE_LIST': {
			return {
				...state,
				visits: state.visits.map((v) => {
					if (v._id === action.payload.visit_id) {
						return {
							...v,
							staff_notes: v.staff_notes.map((sn) => {
								if (sn._id === action.payload._id)
									return {
										...action.payload
									}

								return sn
							})
						}
					}

					return v
				})
			}
		}
		case 'UPDATE_NOTE': {
			const newNotes = state.selected.staff_notes.map((sn) => {
				if (sn._id === action.payload._id)
					return {
						...action.payload
					}

				return sn
			})

			return {
				...state,
				selected: {
					...state.selected,
					staff_notes: newNotes
				}
			}
		}
		case 'SET_VISIT':
			let visit

			if (typeof action.payload === 'string') {
				visit = state.visits.find((visit) => visit._id === action.payload)

				return { ...state, selected: visit }
			} else if (typeof action.payload === 'object') {
				const { visit, pets, add_on_services, reports } = action.payload

				visit.add_on_services = add_on_services
				visit.reports = reports

				return {
					...state,
					selected: visit,
					pets,
					loading: false,
					error: null
				}
			}

			break
		case 'POST_VISIT':
			return { ...state, loading: true }
		case 'POST_VISIT_SUCCESS':
			return { ...state, loading: false }
		case 'POST_VISIT_FAIL':
			return {
				...state,
				loading: false,
				error: 'Error while posting a visit.'
			}
		case 'UPDATE_VISIT_PHOTO': {
			return {
				...state,
				selected: {
					...state.selected,
					[action.payload.key]: action.payload.data
				}
			}
		}
		case 'UPDATE_VISIT':
			return { ...state, loading: true }
		case 'STOP_VISIT_LOADING':
			return { ...state, loading: false }
		case 'UPDATE_VISIT_SUCCESS': {
			const visits = state.visits
			let selected = state.selected
			const { visit, add_on_services, pets } = action.payload
			const isSelectedVisit = visit && selected && selected._id === visit._id

			if (visit && visit._id) {
				if (isSelectedVisit) {
					selected = merge(selected, visit)
					selected.dates = [...visit.dates]
					selected.add_on_services = add_on_services ? add_on_services : selected.add_on_services
					selected.pet_ids = visit.pet_ids
					selected.medications = visit.medications
					selected.pets = pets ? pets : selected.pets
					selected.not_present_meds = visit.not_present_meds
					if (visit.cubbies) selected.cubbies = visit.cubbies
					// Explicitly apply grooming quote fields so invoice/UI refresh after service-type reprice
					if (visit.price != null) selected.price = visit.price
					if (visit.quoted_price_min != null) selected.quoted_price_min = visit.quoted_price_min
					if (visit.quoted_price_max != null) selected.quoted_price_max = visit.quoted_price_max
					if (visit.duration != null) selected.duration = visit.duration
					if (visit.grooming_service_type != null)
						selected.grooming_service_type = visit.grooming_service_type
				}

				if (visits && visits.length) {
					const foundIndex = visits.findIndex((currVisit) => currVisit._id === visit._id)

					if (foundIndex !== -1) {
						visits[foundIndex] = merge(visits[foundIndex], visit)
						visits[foundIndex].add_on_services = add_on_services
							? add_on_services
							: selected.add_on_services
						if (visit.cubbies) visits[foundIndex].cubbies = visit.cubbies
						if (visit.price != null) visits[foundIndex].price = visit.price
						if (visit.quoted_price_min != null)
							visits[foundIndex].quoted_price_min = visit.quoted_price_min
						if (visit.quoted_price_max != null)
							visits[foundIndex].quoted_price_max = visit.quoted_price_max
						if (visit.duration != null) visits[foundIndex].duration = visit.duration
						if (visit.grooming_service_type != null)
							visits[foundIndex].grooming_service_type = visit.grooming_service_type
					}
				}
			}

			return {
				...state,
				visits: visits ? [...visits] : null,
				selected: selected ? { ...selected } : null,
				pets: pets ? pets : state.pets,
				loading: false
			}
		}
		case 'UPDATE_VISIT_FAIL':
			return { ...state, loading: false, error: 'Failed to update visit.' }
		case 'UPDATE_ADD_ON':
			return { ...state, loading: true }
		case 'UPDATE_INVENTORY':
			return { ...state, loading: true, error: null }
		case 'UPDATE_INVENTORY_SUCCESS': {
			const { pet_id, inventoryItems } = action.payload

			const fullPetArray = state.pets
				? state.pets.map((pet) => {
						if (pet_id == pet._id) return { ...pet, inventory: inventoryItems }

						return pet
				  })
				: null

			const selectedPetArray =
				state.selected && state.selected.pets
					? state.selected.pets.map((pet) => {
							if (pet_id == pet._id) return { ...pet, inventory: inventoryItems }

							return pet
					  })
					: null

			return {
				...state,
				selected: { ...state.selected, pets: selectedPetArray },
				pets: fullPetArray,
				loading: false,
				error: null
			}
		}
		case 'UPDATE_PET':
			return { ...state, loading: true, error: null }
		case 'UPDATE_PET_FAIL':
			return { ...state, loading: false, error: action.payload }
		case 'UPDATE_PET_SUCCESS': {
			const pet = action.payload

			const fullPetArray = state.pets
				? state.pets.map((p) => {
						if (p._id == pet._id) return { ...p, ...pet }

						return pet
				  })
				: null

			const selectedPetArray =
				state.selected && state.selected.pets
					? state.selected.pets.map((p) => {
							if (p._id == pet._id) return { ...p, ...pet }

							return pet
					  })
					: null

			// let selectedPets = cloneDeep(state.selected.pets);

			// let foundPetIndex = selectedPets.findIndex((p) => p._id === pet._id);

			// if (foundPetIndex !== -1) {
			//   let updatedPet = merge(selectedPets[foundPetIndex], action.payload);

			//   if (pet.food_schedule) updatedPet.food_schedule = pet.food_schedule;
			//   if (pet.tags) updatedPet.tags = pet.tags;
			//   if (pet.intolerances) updatedPet.intolerances = pet.intolerances;
			//   if (pet.food_schedule) updatedPet.food_schedule = pet.food_schedule;
			//   if (pet.facility_food_instructions)
			//     updatedPet.facility_food_instructions =
			//       pet.facility_food_instructions;
			//   if (pet.medications) updatedPet.medications = pet.medications;

			//   selectedPets[foundPetIndex] = { ...updatedPet };
			// }

			return {
				...state,
				selected: { ...state.selected, pets: selectedPetArray },
				pets: fullPetArray,
				loading: false,
				error: null
			}
		}
		case 'UPDATE_ADD_ON_SUCCESS':
			if (!state.selected) {
				return { ...state, loading: false }
			} else {
				const visit = state.selected
				const addOnIndex = visit.add_on_services.findIndex(
					(add_on_service) => add_on_service._id === action.payload._id
				)

				if (addOnIndex !== -1) {
					visit.add_on_services[addOnIndex] = action.payload
				}

				return {
					...state,
					selected: { ...visit },
					loading: false,
					error: null
				}
			}
		case 'UPDATE_ADD_ON_FAIL':
			return { ...state, loading: false, error: 'Failed to update enrichment.' }
		case 'UPDATE_VISIT_ASSIGNMENTS':
			return { ...state, loading: true }
		case 'UPDATE_VISIT_ASSIGNMENTS_FAIL':
			return {
				...state,
				loading: false,
				error: 'Failed to update pets assignments visit.'
			}
		case 'DELETE_ADD_ON':
			return { ...state, loading: true, eroor: false }
		case 'DELETE_ADD_ON_SUCCESS': {
			const visit = state.selected
			const addOn = action.payload

			if (addOn && visit && addOn.visit_id === visit._id) {
				const add_on_services = (visit.add_on_services || []).filter(
					(add_on_service) => String(add_on_service._id) !== String(addOn._id)
				)
				const lineItems = (visit.lineItems || []).filter(
					(lineItem) => String(lineItem.addon_id) !== String(addOn._id)
				)

				return {
					...state,
					selected: { ...visit, add_on_services, lineItems },
					loading: false,
					error: null
				}
			} else {
				return { ...state, loading: false, error: null }
			}
		}
		case 'DELETE_ADD_ON_FAIL':
			return { ...state, loading: false, error: 'Failed to delete enrichment.' }
		case 'DELETE_VISIT': {
			return { ...state, loading: true, error: null }
		}
		case 'DELETE_VISIT_SUCCESS': {
			const deletedVisit = action.payload
			const visits = cloneDeep(state.visits)
			const selected = cloneDeep(state.selected)
			const isSelected = deletedVisit._id === selected._id

			if (deletedVisit && Array.isArray(visits)) {
				const visitIndex = visits.findIndex((visit) => visit._id === deletedVisit._id)

				if (visitIndex !== -1) {
					visits.splice(visitIndex, 1)
				}
			}

			return {
				...state,
				select: isSelected ? null : selected,
				visits,
				loading: false,
				error: null
			}
		}
		case 'DELETE_VISIT_FAIL': {
			return {
				...state,
				loading: false,
				error: 'Failed to delete appointment.'
			}
		}
		case 'UPDATE_VISIT_ITEM': {
			return { ...state, invoiceLoading: true, error: null }
		}
		case 'UPDATE_VISIT_ITEM_SUCCESS': {
			const item = cloneDeep(action.payload)
			const selected = cloneDeep(state.selected)
			const visits = cloneDeep(state.visits)

			if (selected && item && item._id && item.visit_id) {
				if (!selected.hasOwnProperty('lineItems')) selected.lineItems = []

				if (selected._id === item.visit_id) {
					const foundIndex = selected.lineItems.findIndex((l) => l._id === item._id)

					if (foundIndex !== -1) {
						selected.lineItems[foundIndex] = item
					} else {
						selected.lineItems.push(item)
					}
				}
			}

			if (visits && item && item._id && item.visit_id) {
				const foundVisitIndex = visits.findIndex((v) => v._id === item.visit_id)

				if (foundVisitIndex !== -1) {
					if (!visits[foundVisitIndex].hasOwnProperty('lineItems'))
						visits[foundVisitIndex].lineItems = []

					const foundItemIndex = visits[foundVisitIndex].lineItems.findIndex((l) => l._id === item._id)

					if (foundItemIndex !== -1) {
						visits[foundVisitIndex].lineItems[foundItemIndex] = item
					} else {
						visits[foundVisitIndex].lineItems.push(item)
					}
				}
			}

			return { ...state, selected, visits, invoiceLoading: false, error: null }
		}
		case 'DELETE_VISIT_ITEM_SUCCESS': {
			const item = cloneDeep(action.payload)
			const selected = cloneDeep(state.selected)
			const visits = cloneDeep(state.visits)

			if (selected && item && item._id && item.visit_id) {
				if (!selected.hasOwnProperty('lineItems')) selected.lineItems = []

				if (selected._id === item.visit_id) {
					const foundIndex = selected.lineItems.findIndex((l) => l._id === item._id)

					if (foundIndex !== -1) {
						selected.lineItems = selected.lineItems.filter((i) => i._id !== item._id)
					}
				}
			}

			if (visits && item && item._id && item.visit_id) {
				const foundVisitIndex = visits.findIndex((v) => v._id === item.visit_id)

				if (foundVisitIndex !== -1) {
					if (!visits[foundVisitIndex].hasOwnProperty('lineItems'))
						visits[foundVisitIndex].lineItems = []

					const foundItemIndex = visits[foundVisitIndex].lineItems.findIndex((l) => l._id === item._id)

					if (foundItemIndex !== -1) {
						visits[foundVisitIndex].lineItems = visits[foundVisitIndex].lineItems.filter(
							(i) => i._id !== item._id
						)
					}
				}
			}

			return { ...state, selected, visits, invoiceLoading: false, error: null }
		}
		case 'ADD_VISIT_ITEM_SUCCESS': {
			const item = cloneDeep(action.payload)
			const selected = cloneDeep(state.selected)
			const visits = cloneDeep(state.visits)

			if (selected && item && item.visit_id) {
				if (!selected.hasOwnProperty('lineItems')) selected.lineItems = []

				selected.lineItems.push(item)
			}

			if (visits && item && item.visit_id) {
				const foundVisitIndex = visits.findIndex((v) => v._id === item.visit_id)

				if (foundVisitIndex !== -1) {
					if (!visits[foundVisitIndex].hasOwnProperty('lineItems'))
						visits[foundVisitIndex].lineItems = []

					visits[foundVisitIndex].lineItems.push(item)
				}
			}

			return { ...state, selected, visits, invoiceLoading: false, error: null }
		}
		case 'UPDATE_VISIT_ITEM_FAIL': {
			return {
				...state,
				invoiceLoading: false,
				error: action.payload || 'Failed to update invoice item.'
			}
		}
		case 'CLEAR_VISITS':
			return { ...state, visits: null, training_enrollments: [], loading: false, error: null }
		case 'CLEAR_VISIT':
			return { ...state, visit: null, loading: false, error: null }
		default:
			return state
	}
}

export default visits
